import { dataService } from 'App';

const  iysUrlStart = '/users/iys';


export function getBrandCodes(taxNumber) {
  return dataService.get(`${iysUrlStart}/list/${taxNumber}`);
}

export function getUserBrandcodes() {
  return dataService.get(`${iysUrlStart}/all`);
}


